export const MARKETPLACE_ROOT = "/novatra/marketplace";
export const marketplaceRoute = (path = "") => `${MARKETPLACE_ROOT}${path}`;
